export default "__VITE_ASSET__4d743e44__"